<template>
    <div class="swiper-out hand-shape">
        <el-carousel  trigger="click" :loop="false" v-if="showSwiper">
          <el-carousel-item v-for="(item,index) in bannerList" :key="index">
            <div @click="goUrl(item.url)" class="img-box">
              <img class="swiper-img" :src="item.img" :alt="item.description"/>
            </div>
          </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
export default {
    props: {
      bannerList:{
            type:Array,
            default:()=>{}
        },
    },
    components: {
      
    },
    data() {
        return {
            banner: [],
            swiperHeight:500
        };
    },
    computed: {
        // 这里计算数据的长度，以此来判断是否显示，这个貌似要必写
        showSwiper () {
            return this.bannerList.length
        }
    },
    created () {
     
	},
    methods:{
      goUrl(url){
        if(url.length>0){
            window.open(url);
        } 
      },
    }
   
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/swiperBanner.vue